// Hardcoded frontend build number — must match the backend's APP_VERSION.
// Increment by 1 every time you ship a new frontend bundle (1, 2, 3, …, 13, …).
// The backend exposes its current expected number at GET /api/version. If the
// two don't match, VersionGate prompts the user to reload so IIS / browser
// caches stop serving an old bundle.
//
// To bump: change this number AND the backend's APP_VERSION (env var or the
// default in src/app.js) so they match the new build.
export const APP_VERSION = 4;
